// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file cadendar/defaultmaterials/v1/default_materials.proto (package cadendar.defaultmaterials.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cadendar/defaultmaterials/v1/default_materials.proto.
 */
export const file_cadendar_defaultmaterials_v1_default_materials: GenFile = /*@__PURE__*/
  fileDesc("CjRjYWRlbmRhci9kZWZhdWx0bWF0ZXJpYWxzL3YxL2RlZmF1bHRfbWF0ZXJpYWxzLnByb3RvEhxjYWRlbmRhci5kZWZhdWx0bWF0ZXJpYWxzLnYxIiYKEkdldFNldHRpbmdzUmVxdWVzdBIQCghvd25lcl9pZBgBIAEoCSJxChNTYXZlU2V0dGluZ3NSZXF1ZXN0EhAKCG93bmVyX2lkGAEgASgJEkgKCHNldHRpbmdzGAIgASgLMjYuY2FkZW5kYXIuZGVmYXVsdG1hdGVyaWFscy52MS5EZWZhdWx0TWF0ZXJpYWxzU2V0dGluZ3MiXwoTR2V0U2V0dGluZ3NSZXNwb25zZRJICghzZXR0aW5ncxgBIAEoCzI2LmNhZGVuZGFyLmRlZmF1bHRtYXRlcmlhbHMudjEuRGVmYXVsdE1hdGVyaWFsc1NldHRpbmdzImAKFFNhdmVTZXR0aW5nc1Jlc3BvbnNlEkgKCHNldHRpbmdzGAEgASgLMjYuY2FkZW5kYXIuZGVmYXVsdG1hdGVyaWFscy52MS5EZWZhdWx0TWF0ZXJpYWxzU2V0dGluZ3MirgEKGERlZmF1bHRNYXRlcmlhbHNTZXR0aW5ncxJHChFkZWZhdWx0X2J5X2ZhbWlseRgBIAMoCzIsLmNhZGVuZGFyLmRlZmF1bHRtYXRlcmlhbHMudjEuRmFtaWx5TWF0ZXJpYWwSSQoRbmV0d29ya19vdmVycmlkZXMYAiADKAsyLi5jYWRlbmRhci5kZWZhdWx0bWF0ZXJpYWxzLnYxLk5ldHdvcmtPdmVycmlkZXMiYAoORmFtaWx5TWF0ZXJpYWwSDgoGZmFtaWx5GAEgASgJEhoKDW1hdGVyaWFsX2NvZGUYAiABKAlIAIgBARIQCghkaXNhYmxlZBgDIAEoCEIQCg5fbWF0ZXJpYWxfY29kZSJkChBOZXR3b3JrT3ZlcnJpZGVzEg8KB25ldHdvcmsYASABKAkSPwoJbWF0ZXJpYWxzGAIgAygLMiwuY2FkZW5kYXIuZGVmYXVsdG1hdGVyaWFscy52MS5GYW1pbHlNYXRlcmlhbDKEAgoXRGVmYXVsdE1hdGVyaWFsc1NlcnZpY2UScgoLR2V0U2V0dGluZ3MSMC5jYWRlbmRhci5kZWZhdWx0bWF0ZXJpYWxzLnYxLkdldFNldHRpbmdzUmVxdWVzdBoxLmNhZGVuZGFyLmRlZmF1bHRtYXRlcmlhbHMudjEuR2V0U2V0dGluZ3NSZXNwb25zZRJ1CgxTYXZlU2V0dGluZ3MSMS5jYWRlbmRhci5kZWZhdWx0bWF0ZXJpYWxzLnYxLlNhdmVTZXR0aW5nc1JlcXVlc3QaMi5jYWRlbmRhci5kZWZhdWx0bWF0ZXJpYWxzLnYxLlNhdmVTZXR0aW5nc1Jlc3BvbnNlYgZwcm90bzM");

/**
 * @generated from message cadendar.defaultmaterials.v1.GetSettingsRequest
 */
export type GetSettingsRequest = Message<"cadendar.defaultmaterials.v1.GetSettingsRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;
};

/**
 * Describes the message cadendar.defaultmaterials.v1.GetSettingsRequest.
 * Use `create(GetSettingsRequestSchema)` to create a new message.
 */
export const GetSettingsRequestSchema: GenMessage<GetSettingsRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_defaultmaterials_v1_default_materials, 0);

/**
 * @generated from message cadendar.defaultmaterials.v1.SaveSettingsRequest
 */
export type SaveSettingsRequest = Message<"cadendar.defaultmaterials.v1.SaveSettingsRequest"> & {
  /**
   * @generated from field: string owner_id = 1;
   */
  ownerId: string;

  /**
   * @generated from field: cadendar.defaultmaterials.v1.DefaultMaterialsSettings settings = 2;
   */
  settings?: DefaultMaterialsSettings | undefined;
};

/**
 * Describes the message cadendar.defaultmaterials.v1.SaveSettingsRequest.
 * Use `create(SaveSettingsRequestSchema)` to create a new message.
 */
export const SaveSettingsRequestSchema: GenMessage<SaveSettingsRequest> = /*@__PURE__*/
  messageDesc(file_cadendar_defaultmaterials_v1_default_materials, 1);

/**
 * @generated from message cadendar.defaultmaterials.v1.GetSettingsResponse
 */
export type GetSettingsResponse = Message<"cadendar.defaultmaterials.v1.GetSettingsResponse"> & {
  /**
   * @generated from field: cadendar.defaultmaterials.v1.DefaultMaterialsSettings settings = 1;
   */
  settings?: DefaultMaterialsSettings | undefined;
};

/**
 * Describes the message cadendar.defaultmaterials.v1.GetSettingsResponse.
 * Use `create(GetSettingsResponseSchema)` to create a new message.
 */
export const GetSettingsResponseSchema: GenMessage<GetSettingsResponse> = /*@__PURE__*/
  messageDesc(file_cadendar_defaultmaterials_v1_default_materials, 2);

/**
 * @generated from message cadendar.defaultmaterials.v1.SaveSettingsResponse
 */
export type SaveSettingsResponse = Message<"cadendar.defaultmaterials.v1.SaveSettingsResponse"> & {
  /**
   * @generated from field: cadendar.defaultmaterials.v1.DefaultMaterialsSettings settings = 1;
   */
  settings?: DefaultMaterialsSettings | undefined;
};

/**
 * Describes the message cadendar.defaultmaterials.v1.SaveSettingsResponse.
 * Use `create(SaveSettingsResponseSchema)` to create a new message.
 */
export const SaveSettingsResponseSchema: GenMessage<SaveSettingsResponse> = /*@__PURE__*/
  messageDesc(file_cadendar_defaultmaterials_v1_default_materials, 3);

/**
 * @generated from message cadendar.defaultmaterials.v1.DefaultMaterialsSettings
 */
export type DefaultMaterialsSettings = Message<"cadendar.defaultmaterials.v1.DefaultMaterialsSettings"> & {
  /**
   * @generated from field: repeated cadendar.defaultmaterials.v1.FamilyMaterial default_by_family = 1;
   */
  defaultByFamily: FamilyMaterial[];

  /**
   * @generated from field: repeated cadendar.defaultmaterials.v1.NetworkOverrides network_overrides = 2;
   */
  networkOverrides: NetworkOverrides[];
};

/**
 * Describes the message cadendar.defaultmaterials.v1.DefaultMaterialsSettings.
 * Use `create(DefaultMaterialsSettingsSchema)` to create a new message.
 */
export const DefaultMaterialsSettingsSchema: GenMessage<DefaultMaterialsSettings> = /*@__PURE__*/
  messageDesc(file_cadendar_defaultmaterials_v1_default_materials, 4);

/**
 * An omitted family entry inherits no value. Within an entry, disabled maps to
 * the explicit JSON null and material_code maps to a configured material.
 *
 * @generated from message cadendar.defaultmaterials.v1.FamilyMaterial
 */
export type FamilyMaterial = Message<"cadendar.defaultmaterials.v1.FamilyMaterial"> & {
  /**
   * @generated from field: string family = 1;
   */
  family: string;

  /**
   * @generated from field: optional string material_code = 2;
   */
  materialCode?: string | undefined;

  /**
   * @generated from field: bool disabled = 3;
   */
  disabled: boolean;
};

/**
 * Describes the message cadendar.defaultmaterials.v1.FamilyMaterial.
 * Use `create(FamilyMaterialSchema)` to create a new message.
 */
export const FamilyMaterialSchema: GenMessage<FamilyMaterial> = /*@__PURE__*/
  messageDesc(file_cadendar_defaultmaterials_v1_default_materials, 5);

/**
 * @generated from message cadendar.defaultmaterials.v1.NetworkOverrides
 */
export type NetworkOverrides = Message<"cadendar.defaultmaterials.v1.NetworkOverrides"> & {
  /**
   * @generated from field: string network = 1;
   */
  network: string;

  /**
   * @generated from field: repeated cadendar.defaultmaterials.v1.FamilyMaterial materials = 2;
   */
  materials: FamilyMaterial[];
};

/**
 * Describes the message cadendar.defaultmaterials.v1.NetworkOverrides.
 * Use `create(NetworkOverridesSchema)` to create a new message.
 */
export const NetworkOverridesSchema: GenMessage<NetworkOverrides> = /*@__PURE__*/
  messageDesc(file_cadendar_defaultmaterials_v1_default_materials, 6);

/**
 * @generated from service cadendar.defaultmaterials.v1.DefaultMaterialsService
 */
export const DefaultMaterialsService: GenService<{
  /**
   * @generated from rpc cadendar.defaultmaterials.v1.DefaultMaterialsService.GetSettings
   */
  getSettings: {
    methodKind: "unary";
    input: typeof GetSettingsRequestSchema;
    output: typeof GetSettingsResponseSchema;
  },
  /**
   * @generated from rpc cadendar.defaultmaterials.v1.DefaultMaterialsService.SaveSettings
   */
  saveSettings: {
    methodKind: "unary";
    input: typeof SaveSettingsRequestSchema;
    output: typeof SaveSettingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_cadendar_defaultmaterials_v1_default_materials, 0);

